<template>
  <div class="ma-4">
    <div v-if="qr2fa==='already activated'" style="height: 400px;">
        <h2 class="text--primary">Fitur Verifikasi 2 langkah telah aktif</h2>
    </div>
    <div v-if="qr2fa!=='already activated'" style="height: 400px">
      <h2>Verifikasi 2 tahap</h2>
      <p>Tambahan keamanan login dengan menggunakan verifikasi 2 tahap dengan menggunakan Applikasi Google</p>
      <v-layout>
        <v-flex xs12 sm12 md12 lg2>
          <div class="crcode border_all">
            <qrcode-vue :value="qr2fa" :size="200" level="H" />
          </div>
        </v-flex>
        <v-flex xs12 sm12 md12 lg4>
          <div class="crcode-desc">
            <v-form>
              <v-text-field
                  v-model="validationcode"
                  name="code"
                  data-v-name="code"
                  type="text"
                  label="Kode Google Authenticator"
                  required>
              </v-text-field>
              <v-btn  class="primary" @click.native="doverify()" :loading="loading">Aktifkan</v-btn>
            </v-form>
          </div>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'SecurityProfile',
  components: {
    QrcodeVue
  },
  data: () => ({
    qrvalue: 'mantappp',
    validationcode: ''
  }),
  mounted () {
    this.getQr2fa()
  },
  computed: {
    ...mapState('UserStore', ['qr2fa'])
  },
  methods: {
    ...mapActions('UserStore', ['getQr2fa', 'verifyAct2fa']),
    doverify () {
      this.$confirm('Yakin akan Aktifkan Verifikasi 2 langkah? setiap anda login akan diminta untuk memasukkan kode otp dari appliaksi Google Authenticator', { color: 'orange', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          this.verifyAct2fa(this.validationcode)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
